import { render, staticRenderFns } from "./ReferralLinkCard.vue?vue&type=template&id=1a59349d&scoped=true"
import script from "./ReferralLinkCard.vue?vue&type=script&lang=ts"
export * from "./ReferralLinkCard.vue?vue&type=script&lang=ts"
import style0 from "./ReferralLinkCard.vue?vue&type=style&index=0&id=1a59349d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a59349d",
  null
  
)

export default component.exports